import { CustodianStatementLink } from "@/shared/types";

export const footerTemplate = "UmbFooter";

export const investmentRiskDisclaimer = null;

export const taxLink: CustodianStatementLink = {
  url: "/portal-redirect?portalType=tax",
  target: "_self"
};

export const statementsLink: CustodianStatementLink = {
  url: "/portal-redirect?portalType=estatements",
  target: "_self"
};

export const displayMyProfileEditMode = true;

export const logoutRedirectUrl = null;

export const faqTemplate = "UmbForms";

export const faqInstructionsTemplate = "";

export const faqLinkAddress = "";

export const displayAdvice = true;

export const displayFaqExternalLinks = false;

export const displayFaqInstructions = false;

export const displayInvestmentsSection = true;

export const disabledRouteRedirectTarget = null;

export const displaySettingsLinkedAccounts = true;

export const allowEmailEdit = false;

export const priorYearContributionOption = true;

export const allowReimbursement = true;

export const showPendingReimbursements = false;

export const showAlternateOnboardingCompleteMessage = false;

const disabledRoutesDictionary = {};

export const disabledRoutes = disabledRoutesDictionary;

export const umbMaximumAddressLineLength = 26;

export const termsUrl = "https://p1.aprimocdn.net/umb/845a0b13-1bfb-4074-b8ae-b06c015b9ba7/TC021_Bend_HSA_New_Account_Packet_021_Original_file.pdf";

export const feeTemplate = "TermsFeeSchedule";

export const quarterlyPaperStatementFee = 1.5;

export const manageHsaCardsInPortal = false;

export const displayPriorYearContributionDisclaimerCopy = false;

export const investmentCustodian = "umb";

export const displayProjectedContributions = true;

export const allowUserToEditContributions = true;

export const displayPdfForESign = true;

export const eSignPdfUrl = "https://content.umb.com/file?uuid=c50b82e1-2658-4bba-a977-07a5d9917378";

export const displayHealthcareBluebookLink = false;

export const displayFooterLegalSection = true;

export const contactDetailsSetAtBank = false;

export const showHsaStoreShopTab = true;

export const displayHealthcareClaims = true;